import axios, { CancelTokenSource } from 'axios';
import { Message } from 'element-ui';
import * as Msal from "msal";
import store from '@/store';

const env = process.env; //获取当前环境

//Server Client  APP  B2C配置 ：MSAL 常量
const appConfig = {
	b2cScopes: ["api://34c89148-fb33-4279-bf4c-3fac6e2a4301/access_as_user"],
	webApi: "https://fabrikamb2chello.azurewebsites.net/hello"
};

//client APPlication 配置 ： 常量
const myMSALObj = new Msal.UserAgentApplication({
	auth: {
		clientId: "2fffca24-2385-4240-8f25-d1fd2bfc1898", //client ID
		authority: "https://login.microsoftonline.com/onecareercwi.onmicrosoft.com", //tenant info
		validateAuthority: false
	},
	cache: {
		cacheLocation: "localStorage",   //缓存位置
		storeAuthStateInCookie: true
	}
});

//login请求 参数
const loginRequest = {
	scopes: appConfig.b2cScopes
};

//token请求 参数   =   login请求 参数
const tokenRequest = loginRequest;

/*通用url配置*/
//系统前端跳转页面
let getLogin = env.VUE_APP_FRONT_PAGE;
//系统后端请求页面
let getUrl = env.VUE_APP_API_URL;


//企业微信配置信息
let wxAppid = "wwafb540beed8e0eb9";
let wxAgentid = env.VUE_APP_WXAGENT_ID;
let wxState = "onecareercwi";


let loadCount = 0;
let messageBox: any = null;
let CancelToken = axios.CancelToken;
var source: CancelTokenSource | any = CancelToken.source();

//日志
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: 'bac28039-c4e1-45ea-a354-39d931b0ae58'//key
		/* ...Other Configuration Options... */
	}
});
appInsights.loadAppInsights();
appInsights.trackPageView();
interface Ilog {
	info: string,//接口说明
	status: string,//请求状态  正常/请求失败
	params: object | string,//参数
	result: string,//返回值
	error: string,//异常信息
	level: number//等级
}
export default {

	GetLogin() {
		return getLogin;
	},
	//发送遥测
	sendTrace(log: String) {
		appInsights.trackTrace({ message: this.getAccountName() + '——' + this.getUserId() + ':' + log, severityLevel: 0 });//追踪
	},
	//发送报错信息
	exception(log: String) {
		appInsights.trackTrace({ message: this.getAccountName() + '——' + this.getUserId() + ':' + log, severityLevel: 3 });//报错信息
	},
	//发送系统追踪遥测
	sendRequestTrace(log: Ilog) {
		let logDetail = {
			"user": this.getAccountName() + "——" + this.getUserId(),//用户信息
			"info": log.info,//接口说明
			"status": log.status,//请求状态  正常/请求失败
			"params": log.params,//参数
			"result": log.result,//返回值
			"error": log.error,//异常信息
		};
		//发送日志
		appInsights.trackTrace({ message: JSON.stringify(logDetail).toString(), severityLevel: log.level });
	},

	getAccountEmail(): String {
		//检查是否有登录模式缓存
		if (localStorage.getItem("loginType") != undefined) {
			if (localStorage.getItem("loginType") == 1) {
				return myMSALObj.getAccount().idTokenClaims.preferred_username;
			}
			if (localStorage.getItem("loginType") == 2) {
				if (localStorage.getItem("weChatUser") != undefined) {
					return JSON.parse(localStorage.getItem("weChatUser")).email;
				} else {
					return "";
				}
			}
		} else {
			return "";
		}
	},
	//账户姓名
	getAccountName(): string {
		//检查是否有登录模式缓存
		if (localStorage.getItem("loginType") != undefined) {
			if (localStorage.getItem("loginType") == 1) {
				return myMSALObj.getAccount().name;
			}
			if (localStorage.getItem("loginType") == 2) {
				if (localStorage.getItem("weChatUser") != undefined) {
					return JSON.parse(localStorage.getItem("weChatUser")).userName;
				} else {
					return "";
				}
			}
		} else {
			return "";
		}
	},
	//获取用户b2cid
	getUserId() {
		//检查是否有登录模式缓存
		if (localStorage.getItem("loginType") != undefined) {
			if (localStorage.getItem("loginType") == 1) {
				if (myMSALObj.getAccount() != null) {
					return myMSALObj.getAccount().accountIdentifier
				} else {
					return "";
				}
			}
			if (localStorage.getItem("loginType") == 2) {
				if (localStorage.getItem("weChatUser") != undefined) {
					return JSON.parse(localStorage.getItem("weChatUser")).userId;
				} else {
					return "";
				}
			}
		} else {
			return "";
		}
	},
	//封装登录
	signIn() {
		//清除原先所有缓存
		localStorage.clear();
		const mgs = Message({
			message: '正在登录，请在新打开的页面进行登录操作。',
			type: "warning",
			iconClass: "el-icon-loading",
			duration: 99999
		});
		myMSALObj.loginPopup(loginRequest).then(function (loginResponse) {
			mgs.close();
			Message({
				message: '登录成功',
				type: "success",
				duration: 2000
			});
			//获取用户姓名存入本地缓存
			localStorage.setItem("username", myMSALObj.getAccount().name);
			//存入登录类型
			localStorage.setItem("loginType", 1);
			//跳转首页
			window.location.href = getLogin + "#/Welcome";
		}).catch(function (error) {
			mgs.close();
			console.log(error)
		});
	},

	//封装退出登录
	logout() {

		if (localStorage.getItem("loginType") == undefined) {
			localStorage.clear();
			myMSALObj.logout();
			window.location.href = getLogin;
		}

		//邮箱登录
		if (localStorage.getItem("loginType") == 1) {
			localStorage.clear();
			//退出登录
			myMSALObj.logout();
		}

		//企业微信登录
		if (localStorage.getItem("loginType") == 2) {
			localStorage.clear();
			window.location.href = getLogin;
		}

	},
	//校验是否登录，如果已经登陆过，则跳转首页，
	checkToken() {
		if (localStorage.getItem("loginType") != undefined) {

			//邮箱登录
			if (localStorage.getItem("loginType") == 1) {
				myMSALObj.acquireTokenSilent(tokenRequest).then((tokenResponse) => {
					//跳转首页
					window.location.href = getLogin + "#/Welcome";
				}).catch((error) => {
					//错误信息
				});
			}

			//企业微信登录
			if (localStorage.getItem("loginType") == 2) {
				window.location.href = getLogin + "#/Welcome";
			}
		}

	},
	urlencode(str) {
		str = (str + '').toString();
		return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
	},
	weChatLogin() {
		window.location.href = "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=" + wxAppid + "&agentid=" + wxAgentid + "&redirect_uri=" + this.urlencode(getLogin + "#/") + "&state=" + wxState;
	},
	checkWeChatLogin(param) {
		if (param.appid != null && param.code != null && param.state != null && param.appid == wxAppid && param.state == wxState) {
			let mgs: any = null;
			mgs = Message({
				message: "正在校验登录信息",
				type: "warning",
				iconClass: "el-icon-loading",
				duration: 99999
			});
			console.log(param)
			//根据code获取用户信息
			return new Promise((resolve, reject) => {
				let params = {
					method: "get", url: getUrl + "userInfo/checkWeChatUser", params: { code: param.code }, headers: {
						'content-type': 'application/json',
					}
				};
				this.request(params, "后台校验企业微信用户是否存在", false).then((data) => {
					mgs.close();
					resolve(data);
				}).catch(data => {
					mgs.close();
					reject(data);
				})
			})
		}

	},
	//跳转页面，用于网页之间的跳转 -- 未使用到
	navigateTo($router: any, routerName: string, e: any, query: any) {
		if (e && e.ctrlKey) {
			const routeData = $router.resolve({
				name: routerName,
				query,
			});
			window.open(routeData.href, '_blank');
		} else {
			$router.push({
				name: routerName,
				query
			});
		}
	},
	//cookie操作
	setCookie(cname: string, cvalue: string, exdays: number) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 2 * 60 * 60 * 1000));
		const expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + "; " + expires;
	},
	//获取cookie 
	getCookie(cname: string) {
		const name = cname + "=";
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1);
			if (c.indexOf(name) != -1) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},

	//校验登录模式并返回相应的head用于request请求
	checkLoginType() {
		return new Promise((resolve, reject) => {
			//检查是否有登录模式缓存
			if (localStorage.getItem("loginType") != undefined) {
				//邮箱登录
				if (localStorage.getItem("loginType") == 1) {
					//调用acquireTokenSilent获取token
					myMSALObj.acquireTokenSilent(tokenRequest).then((tokenResponse) => {
						resolve({
							'content-type': 'application/json',
							'Authorization': 'Bearer ' + tokenResponse.accessToken,
							'loginType': '1',
						});
					}).catch((error) => {
						window.location.href = getLogin;
					});
				}

				//企业微信登录
				if (localStorage.getItem("loginType") == 2) {

					if (localStorage.getItem("weChatUser") != undefined) {
						resolve({
							'content-type': 'application/json',
							'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("weChatUser")).uuid,
							'loginType': '2',
						});
					} else {
						window.location.href = getLogin;
					}
				}
			} else {
				window.location.href = getLogin;
			}
		})
	},
	//后端请求封装方法
	request(params, info, ifShow) {
		return new Promise((resolve, reject) => {
			this.loadingBox(0, ifShow);
			let logDetail = { "info": info, "params": JSON.stringify(params.datas), "status": "正常", "level": 1, "result": '', "error": '' };
			axios(params).then(res => {
				if (res.status == 500) {
					Message({
						message: '网络错误！(如果频繁出现此信息,请联系系统管理员)',
						type: "warning",
					});
				}
				switch (res.data) {
					case -401:
					case -402:
						Message({
							message: '登录失效，请重新登录',
							type: "warning",
						});
						logDetail.status = "token出现问题，值:" + res.data;
						logDetail.level = 2;
						reject('登录失效，请重新登录');
						window.location.href = getLogin;
						break;
					case -407:
						reject("用户信息校验失败，请重新登录！");
						logDetail.status = "用户信息校验失败，值:" + res.data;
						logDetail.level = 2;
						window.location.href = getLogin;
						break;
					default:
						logDetail.result = JSON.stringify(res.data);
						resolve(res.data);
				}
			}).catch(res => {
				Message({
					message: '网络错误！(如果频繁出现此信息,请联系网页管理员)',
					type: "warning",
				});
				logDetail.error = JSON.stringify(res);
				logDetail.status = "后端错误";
				logDetail.level = 3;
				reject(res);
			}).finally(() => {
				this.loadingBox(1, ifShow);
				//发送日志
				this.sendRequestTrace(logDetail);
			});
		})

	},

	//post ajax请求
	requestPost(info: string, urls: string, datas: any, ifShow?: any) {
		return new Promise((resolve, reject) => {
			//调用acquireTokenSilent获取token
			this.checkLoginType().then((headers) => {
				let params = { method: "post", url: getUrl + urls, data: datas, headers: headers };
				this.request(params, info, ifShow).then((data) => {
					resolve(data);
				}).catch(data => {
					reject(data);
				})
			}).catch(res => {
				window.location.href = getLogin;
			})
		})
	},
	//patch ajax请求
	requestPatch(info: string, urls: string, datas: any, ifShow?: any) {
		return new Promise((resolve, reject) => {
			//调用acquireTokenSilent获取token
			this.checkLoginType().then((headers) => {
				let params = { method: "patch", url: getUrl + urls, data: datas, headers: headers };
				this.request(params, info, ifShow).then((data) => {
					resolve(data);
				}).catch(data => {
					reject(data);
				})
			}).catch(res => {
				window.location.href = getLogin;
			})
		})
	},
	//Get ajax请求
	requestGet(info: string, urls: string, datas: any, ifShow?: any) {
		return new Promise((resolve, reject) => {
			//调用acquireTokenSilent获取token
			this.checkLoginType().then((headers) => {
				let params = { method: "get", url: getUrl + urls, params: datas, headers: headers };
				this.request(params, info, ifShow).then((data) => {
					resolve(data);
				}).catch(data => {
					reject(data);
				})
			}).catch(res => {
				window.location.href = getLogin;
			})
		})
	},
	//获取美元额度汇率
	getUSDExchangeRate(dates: any): any {
		var that = this;
		return new Promise((resolve, reject) => {
			//调用acquireTokenSilent获取token
			that.checkLoginType().then((headers) => {
				let params = {
					method: "get",
					url: dates == null ? (getUrl + "course/getNowRate") : (getUrl + "course/getDateRate?time=" + this.getDetailTime(dates, 4)),
					headers: headers
				};
				that.request(params, "从后端获取汇率", true).then((data) => {
					resolve(data);
				}).catch(data => {
					reject(data);
				})
			}).catch(res => {
				window.location.href = getLogin;
			})
		})
	},
	getUSDRate_time(dates: any): any {
		return new Promise((resolve, reject) => {
			this.getUSDExchangeRate(dates).then((rate: any) => {
				resolve(rate);
			});
		})

	},
	//获取指定日期的时间格式
	getDetailTime(dates: any, tab: number) {
		const date: Date = new Date(dates);
		const year: number | string = date.getFullYear()
		let month: number | string = date.getMonth() + 1
		let day: number | string = date.getDate()
		let hour: number | string = date.getHours()
		let minute: number | string = date.getMinutes()
		let second: number | string = date.getSeconds()
		month = String(month).padStart(2, "0");
		day = String(day).padStart(2, "0");
		hour = String(hour).padStart(2, "0");
		minute = String(minute).padStart(2, "0");
		second = String(second).padStart(2, "0");
		//返回时间 yyyy年MM月DD日 时:分:秒
		if (tab == 1) {
			return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
		}
		//返回时间 yyyy年MM月DD日 时:分
		if (tab == 2) {
			return year + "-" + month + "-" + day + " " + hour + ":" + minute;
		}
		//返回时间 yyyy年MM月DD日
		if (tab == 3) {
			return year + "年" + month + "月" + day + "日";
		}
		//返回时间 yyyy-MM-DD
		if (tab == 4) {
			return year + "-" + month + "-" + day;
		}
		//返回时间 yyyy-MM-DD  00：00：00
		if (tab == 5) {
			return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
		}

		//返回时间 yyyy-MM-DD  00：00
		if (tab == 6) {
			return year + "-" + month + "-" + day + " " + hour + ":" + minute;
		}
	},
	//将字符串日期或date转换为UTC时间戳
	getUTCTime(str) {
		var date = new Date(str);
		var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
			date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
		return now_utc;
	},
	//将字符串日期或date转换为时间段显示 如:2022-11-11 10:00 转换为 2022-11-11 10:00 ~ 11:00
	dateToPhase(str) {
		let date = new Date(str);
		return this.getDetailTime(date, 2) + " ~ " + ((date.getHours() + 1) < 10 ? "0" : "") + (date.getHours() + 1) + ":00";
	},
	//加载框方法
	//ifAdd 请求时0，loadCount++；
	//ifAdd 请求结束后1，loadCount--；
	//ifShow 如果不为undefined，则不计入这次请求
	loadingBox(ifAdd: number, ifShow: any) {
		if (ifShow == undefined) {
			if (ifAdd == 0) {
				//+1
				loadCount = loadCount + 1;
			} else {
				//-1
				loadCount = loadCount - 1;
			}
			// == 0 时，关闭弹出框
			if (loadCount != 0) {
				// 第一次messageBox为null，直接显示
				if (messageBox == null) {
					//弹出
					messageBox = Message({
						message: '正在加载',
						type: "warning",
						iconClass: "el-icon-loading",
						duration: 0
					});
					//之后判断是否正在显示，如果为已关闭，则显示弹出框
				} else {
					if (messageBox.closed) {
						messageBox = Message({
							message: '正在加载',
							type: "warning",
							iconClass: "el-icon-loading",
							duration: 0
						});
					}
				}
			} else {
				//关闭弹出框
				messageBox.close();
			}
		}
	},
	cancelRequest() {
		if (typeof source === 'function') {
			source('终止请求')
		}
	},
	//上传文件 post请求
	/**
	 * @param {String} urls 上传路径
	 * @param {Object} datas 上传的文件 
	 * @param {String} info 接口说明
	 */
	requestUploadPost(info: any, urls: any, datas: any) {
		return new Promise((resolve, reject) => {
			let mgs: any = null;
			mgs = Message({
				message: "正在上传",
				type: "warning",
				iconClass: "el-icon-loading",
				duration: 99999
			});
			//调用acquireTokenSilent获取token
			that.checkLoginType().then((headers) => {
				let params = {
					method: 'post',
					url: getUrl + urls,
					data: datas,
					dataType: 'json',
					contentType: false,
					processData: false,
					headers,
				};
				that.request(params, "上传文件", false).then((data) => {
					mgs.close();
					resolve(data);
				}).catch(data => {
					mgs.close();
					reject(data);
				})
			}).catch(res => {
				mgs.close();
				window.location.href = getLogin;
			})
		})
	},
	//将数字转换为时分
	convertHours(minutes: any) {
		let result = "";
		if (minutes == "+ ∞") {
			result = "无穷大";
		}
		if (minutes == 0) {
			result = "0分钟";
		}
		if (minutes > 0) {
			if (minutes >= 60) {
				result = parseInt(minutes / 60) + "小时" + parseInt(minutes % 60) + "分钟";
			} else {
				result = minutes + "分钟";
			}
		}
		if (minutes < 0) {
			let minute = minutes;
			minute = Math.abs(minute);
			if (minutes <= -60) {
				result = "-" + parseInt(minute / 60) + "小时" + parseInt(minutes % 60) + "分钟";
			} else {
				result = "-" + minute + "分钟";
			}
		}
		if (minutes == -50000) {
			result = "+ ∞";
		}
		return result;
	},
	getFileType(fileName) {
		// 后缀获取
		let suffix = '';
		// 获取类型结果
		let result = '';
		try {
			const flieArr = fileName.split('.');
			suffix = flieArr[flieArr.length - 1];
		} catch (err) {
			suffix = '';
		}
		// fileName无后缀返回 other
		if (!suffix) { return 'other'; }
		suffix = suffix.toLocaleLowerCase();
		// 图片格式
		const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
		// 进行图片匹配
		result = imglist.find(item => item === suffix);
		if (result) {
			return 'image';
		}
		// 匹配txt
		const txtlist = ['txt'];
		result = txtlist.find(item => item === suffix);
		if (result) {
			return 'txt';
		}
		// 匹配 excel
		const excelist = ['xls', 'xlsx'];
		result = excelist.find(item => item === suffix);
		if (result) {
			return 'excel';
		}
		// 匹配 word
		const wordlist = ['doc', 'docx'];
		result = wordlist.find(item => item === suffix);
		if (result) {
			return 'word';
		}
		// 匹配 pdf
		const pdflist = ['pdf'];
		result = pdflist.find(item => item === suffix);
		if (result) {
			return 'pdf';
		}
		// 匹配 ppt
		const pptlist = ['ppt', 'pptx'];
		result = pptlist.find(item => item === suffix);
		if (result) {
			return 'ppt';
		}
		// 匹配 视频
		const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
		result = videolist.find(item => item === suffix);
		if (result) {
			return 'video';
		}
		// 匹配 音频
		const radiolist = ['mp3', 'wav', 'wmv'];
		result = radiolist.find(item => item === suffix);
		if (result) {
			return 'radio';
		}
		// 其他 文件类型
		return 'other';
	},
}

